import { render, staticRenderFns } from "./JinNangQuery.vue?vue&type=template&id=bc5df18e&scoped=true&"
import script from "./JinNangQuery.vue?vue&type=script&lang=js&"
export * from "./JinNangQuery.vue?vue&type=script&lang=js&"
import style0 from "./JinNangQuery.vue?vue&type=style&index=0&id=bc5df18e&lang=scss&scoped=true&"
import style1 from "./JinNangQuery.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5df18e",
  null
  
)

export default component.exports